import { SubTitle } from './styles';

export default SubTitle;
